module.exports = __webpack_public_path__ + "media/dashboard/assets/images/chachat-bubble-logo-9974fcbac834727c341110a36beea1dd.png";